export default "__VITE_ASSET__fJysWSoM__"